import React, { useState, useEffect, useMemo } from 'react';
import { listenToOrders } from '../services/firebase';
import { computeAnalytics } from '../utils/orders';

export default function Analytics() {
  const [orders, setOrders] = useState([]);

  useEffect(() => listenToOrders(setOrders), []);

  const stats = useMemo(() => computeAnalytics(orders), [orders]);

  return (
    <div className="page-body">
      <div style={{ marginBottom: 24 }}>
        <div style={{ fontFamily: 'Clash Display, sans-serif', fontSize: 24, fontWeight: 700, marginBottom: 4 }}>Analytics</div>
        <div style={{ fontSize: 13, color: 'var(--text2)' }}>Computed from last {orders.length} loaded orders</div>
      </div>

      <div className="stat-grid" style={{ gridTemplateColumns: 'repeat(3, 1fr)' }}>
        <div className="stat-card green">
          <div className="stat-label">REPEAT CUSTOMERS</div>
          <div className="stat-value green">{stats.repeatCustomers}</div>
          <div className="stat-sub">of {stats.totalCustomers} unique delivered</div>
        </div>
        <div className="stat-card orange">
          <div className="stat-label">DELIVERED</div>
          <div className="stat-value orange">{stats.deliveredCount}</div>
          <div className="stat-sub">{stats.orderCount} total loaded</div>
        </div>
        <div className="stat-card blue">
          <div className="stat-label">REPEAT RATE</div>
          <div className="stat-value blue">
            {stats.totalCustomers ? Math.round((stats.repeatCustomers / stats.totalCustomers) * 100) : 0}%
          </div>
          <div className="stat-sub">customers with 2+ orders</div>
        </div>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 20 }}>
        <div className="table-card">
          <div className="table-header">
            <div className="table-title">Peak order hours</div>
          </div>
          <table>
            <thead><tr><th>HOUR</th><th>ORDERS</th></tr></thead>
            <tbody>
              {stats.peakHours.map((h) => (
                <tr key={h.hour}>
                  <td style={{ fontFamily: 'JetBrains Mono' }}>{h.hour.toString().padStart(2, '0')}:00</td>
                  <td>{h.count}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="table-card">
          <div className="table-header">
            <div className="table-title">Top products</div>
          </div>
          <table>
            <thead><tr><th>PRODUCT</th><th>QTY</th><th>REVENUE</th></tr></thead>
            <tbody>
              {stats.topProducts.length === 0 ? (
                <tr><td colSpan={3} style={{ textAlign: 'center', color: 'var(--text2)', padding: 24 }}>No data</td></tr>
              ) : stats.topProducts.map((p) => (
                <tr key={p.name}>
                  <td>{p.name}</td>
                  <td>{p.qty}</td>
                  <td style={{ fontFamily: 'JetBrains Mono', color: 'var(--green)' }}>₹{p.revenue}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
